export enum VerificationStatusEnum {
    ALL = 'ALL',
    NONE = 'NONE',
    SUCCESSFUL = 'SUCCESSFUL',
    INVALID_ACT_NUMBER = 'INVALID_ACT_NUMBER',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    REFUSED_TO_ACCEPT = 'REFUSED_TO_ACCEPT',
}
